import type {
  BuyAgainReview,
  BuyAgainUnavailableItem,
} from "@convex/schemas/validators/buyAgain";

export function buyAgainDeliveryNote(
  review: Pick<BuyAgainReview, "wasPickup" | "hasDestination">,
): string {
  if (review.wasPickup)
    return "Freight is quoted for the address you enter at checkout.";
  if (!review.hasDestination)
    return "Freight is quoted at checkout.";
  return "Some items changed since your last order. Prices are today's.";
}

export function buyAgainUnavailableReason(
  entry: Pick<BuyAgainUnavailableItem, "reason" | "minimumQuantity">,
): string {
  switch (entry.reason) {
    case "not_a_listing":
      return "Arranged by quote, so it can't be bought online.";
    case "unlisted":
      return "No longer listed.";
    case "below_minimum":
      return entry.minimumQuantity
        ? `Now sold in orders of ${entry.minimumQuantity} or more.`
        : "Below the current minimum order.";
    case "checkout_unavailable":
      return "Not available for online checkout right now.";
    case "needs_quote":
      return "Too large to schedule online.";
  }
}

export function buyAgainAlternativesHref(
  entry: Pick<BuyAgainUnavailableItem, "productTypeSlug">,
): string | null {
  return entry.productTypeSlug
    ? `/listing/category/${entry.productTypeSlug}`
    : null;
}

export const BUY_AGAIN_REQUEST_HREF = "/request-quote?type=buy&source=buy-again";
